import {
  Briefcase, Scale, Stethoscope, GraduationCap, Home, Code, Camera, Dumbbell,
  Scissors, UtensilsCrossed, Plane, Music, Heart, Laptop, Landmark, Factory,
  Store, Megaphone, Pen, Hammer, Car, Shirt, Leaf, Shield, Palette, Wrench,
  Building2, Calculator, BookOpen, Mic, Film, Users, Globe, Zap, Award,
  Clock, Phone, Wifi, Star, Crown, Gem, Rocket, Flame, Sparkles, 
  Activity, Target, CircleDollarSign, Lightbulb, PenTool, Monitor,
  Headphones, Tv, Newspaper, Warehouse, Package, Truck, Anchor,
  Mountain, TreePine, Dog, Baby, Church, HandMetal, Siren, Pill,
  Brain, Eye, Bone, HeartPulse, Smile, Flower2, Brush, Clapperboard,
  MapPin, Compass, Utensils, Wine, Coffee, Cake, Pizza
} from 'lucide-react';

// Comprehensive icon library for profession/industry categories
export const ICON_LIBRARY = [
  // Business & Professional
  { id: 'briefcase', label: 'Business', component: Briefcase, group: 'Business' },
  { id: 'building2', label: 'Corporate', component: Building2, group: 'Business' },
  { id: 'users', label: 'Team/Group', component: Users, group: 'Business' },
  { id: 'target', label: 'Marketing', component: Target, group: 'Business' },
  { id: 'megaphone', label: 'Advertising', component: Megaphone, group: 'Business' },
  { id: 'globe', label: 'International', component: Globe, group: 'Business' },
  { id: 'calculator', label: 'Finance', component: Calculator, group: 'Business' },
  { id: 'circledollarsign', label: 'Banking', component: CircleDollarSign, group: 'Business' },
  { id: 'award', label: 'Executive', component: Award, group: 'Business' },
  { id: 'lightbulb', label: 'Consulting', component: Lightbulb, group: 'Business' },

  // Legal
  { id: 'scale', label: 'Legal/Law', component: Scale, group: 'Legal' },
  { id: 'shield', label: 'Advocate', component: Shield, group: 'Legal' },
  { id: 'landmark', label: 'Government', component: Landmark, group: 'Legal' },

  // Medical & Healthcare
  { id: 'stethoscope', label: 'Doctor', component: Stethoscope, group: 'Healthcare' },
  { id: 'heartpulse', label: 'Cardiology', component: HeartPulse, group: 'Healthcare' },
  { id: 'pill', label: 'Pharmacy', component: Pill, group: 'Healthcare' },
  { id: 'brain', label: 'Neurology', component: Brain, group: 'Healthcare' },
  { id: 'eye', label: 'Ophthalmology', component: Eye, group: 'Healthcare' },
  { id: 'bone', label: 'Orthopedic', component: Bone, group: 'Healthcare' },
  { id: 'smile', label: 'Dentist', component: Smile, group: 'Healthcare' },
  { id: 'activity', label: 'Healthcare', component: Activity, group: 'Healthcare' },
  { id: 'heart', label: 'Wellness', component: Heart, group: 'Healthcare' },
  { id: 'siren', label: 'Emergency', component: Siren, group: 'Healthcare' },

  // Technology
  { id: 'code', label: 'Software', component: Code, group: 'Technology' },
  { id: 'monitor', label: 'IT Services', component: Monitor, group: 'Technology' },
  { id: 'laptop', label: 'Freelancer', component: Laptop, group: 'Technology' },
  { id: 'wifi', label: 'Networking', component: Wifi, group: 'Technology' },
  { id: 'zap', label: 'Electronics', component: Zap, group: 'Technology' },

  // Education
  { id: 'graduationcap', label: 'Education', component: GraduationCap, group: 'Education' },
  { id: 'bookopen', label: 'Teaching', component: BookOpen, group: 'Education' },
  { id: 'pen', label: 'Writing', component: Pen, group: 'Education' },

  // Real Estate & Construction
  { id: 'home', label: 'Real Estate', component: Home, group: 'Real Estate' },
  { id: 'hammer', label: 'Construction', component: Hammer, group: 'Real Estate' },
  { id: 'wrench', label: 'Maintenance', component: Wrench, group: 'Real Estate' },

  // Creative & Design
  { id: 'palette', label: 'Design', component: Palette, group: 'Creative' },
  { id: 'camera', label: 'Photography', component: Camera, group: 'Creative' },
  { id: 'pentool', label: 'Graphic Design', component: PenTool, group: 'Creative' },
  { id: 'brush', label: 'Art', component: Brush, group: 'Creative' },
  { id: 'film', label: 'Videography', component: Film, group: 'Creative' },
  { id: 'clapperboard', label: 'Film/Cinema', component: Clapperboard, group: 'Creative' },

  // Fitness & Sports
  { id: 'dumbbell', label: 'Fitness', component: Dumbbell, group: 'Fitness' },

  // Beauty & Wellness
  { id: 'scissors', label: 'Salon/Beauty', component: Scissors, group: 'Beauty' },
  { id: 'flower2', label: 'Spa/Wellness', component: Flower2, group: 'Beauty' },
  { id: 'sparkles', label: 'Beauty Care', component: Sparkles, group: 'Beauty' },

  // Food & Hospitality
  { id: 'utensilscrossed', label: 'Restaurant', component: UtensilsCrossed, group: 'Food' },
  { id: 'utensils', label: 'Chef/Cooking', component: Utensils, group: 'Food' },
  { id: 'coffee', label: 'Cafe', component: Coffee, group: 'Food' },
  { id: 'wine', label: 'Bar/Lounge', component: Wine, group: 'Food' },
  { id: 'cake', label: 'Bakery', component: Cake, group: 'Food' },

  // Travel & Transport
  { id: 'plane', label: 'Travel', component: Plane, group: 'Travel' },
  { id: 'mappin', label: 'Tourism', component: MapPin, group: 'Travel' },
  { id: 'compass', label: 'Adventure', component: Compass, group: 'Travel' },
  { id: 'truck', label: 'Logistics', component: Truck, group: 'Travel' },
  { id: 'car', label: 'Automotive', component: Car, group: 'Travel' },
  { id: 'anchor', label: 'Marine', component: Anchor, group: 'Travel' },

  // Media & Entertainment
  { id: 'music', label: 'Music', component: Music, group: 'Media' },
  { id: 'mic', label: 'Podcast/Radio', component: Mic, group: 'Media' },
  { id: 'headphones', label: 'Audio/DJ', component: Headphones, group: 'Media' },
  { id: 'tv', label: 'Television', component: Tv, group: 'Media' },
  { id: 'newspaper', label: 'Journalism', component: Newspaper, group: 'Media' },

  // Manufacturing & Retail
  { id: 'factory', label: 'Manufacturing', component: Factory, group: 'Industry' },
  { id: 'store', label: 'Retail/Shop', component: Store, group: 'Industry' },
  { id: 'warehouse', label: 'Warehouse', component: Warehouse, group: 'Industry' },
  { id: 'package', label: 'E-commerce', component: Package, group: 'Industry' },

  // Fashion
  { id: 'shirt', label: 'Fashion', component: Shirt, group: 'Fashion' },
  { id: 'gem', label: 'Jewelry', component: Gem, group: 'Fashion' },
  { id: 'crown', label: 'Luxury', component: Crown, group: 'Fashion' },

  // Agriculture & Nature
  { id: 'leaf', label: 'Agriculture', component: Leaf, group: 'Nature' },
  { id: 'treepine', label: 'Forestry', component: TreePine, group: 'Nature' },
  { id: 'mountain', label: 'Outdoor', component: Mountain, group: 'Nature' },

  // Other
  { id: 'dog', label: 'Pets/Veterinary', component: Dog, group: 'Other' },
  { id: 'baby', label: 'Childcare', component: Baby, group: 'Other' },
  { id: 'church', label: 'Religious', component: Church, group: 'Other' },
  { id: 'star', label: 'Premium', component: Star, group: 'Other' },
  { id: 'rocket', label: 'Startup', component: Rocket, group: 'Other' },
  { id: 'flame', label: 'Trending', component: Flame, group: 'Other' },
  { id: 'phone', label: 'Telecom', component: Phone, group: 'Other' },
  { id: 'clock', label: 'Services', component: Clock, group: 'Other' },
  { id: 'handmetal', label: 'Events', component: HandMetal, group: 'Other' },
];

// Quick lookup: icon id → component
export const getIconComponent = (iconId) => {
  const found = ICON_LIBRARY.find(i => i.id === iconId);
  return found?.component || Briefcase;
};

// Quick lookup: icon id → label
export const getIconLabel = (iconId) => {
  const found = ICON_LIBRARY.find(i => i.id === iconId);
  return found?.label || iconId;
};

// Group icons by category
export const getIconGroups = () => {
  const groups = {};
  ICON_LIBRARY.forEach(icon => {
    if (!groups[icon.group]) groups[icon.group] = [];
    groups[icon.group].push(icon);
  });
  return groups;
};

// Base categories and subcategories seed data
export const SEED_CATEGORIES = [
  {
    name: 'Business & Corporate',
    icon: 'briefcase',
    description: 'Professional cards for business executives and corporates',
    subcategories: [
      { name: 'Executives', icon: 'award', description: 'C-suite and senior management' },
      { name: 'Managers', icon: 'users', description: 'Team leads and managers' },
      { name: 'Consultants', icon: 'lightbulb', description: 'Business and strategy consultants' },
      { name: 'Startups', icon: 'rocket', description: 'Startup founders and teams' },
      { name: 'Marketing', icon: 'megaphone', description: 'Marketing professionals' },
      { name: 'Sales', icon: 'target', description: 'Sales representatives and teams' },
    ]
  },
  {
    name: 'Legal',
    icon: 'scale',
    description: 'Cards for legal professionals',
    subcategories: [
      { name: 'Lawyers', icon: 'scale', description: 'Practicing lawyers' },
      { name: 'Advocates', icon: 'shield', description: 'Court advocates' },
      { name: 'Legal Consultants', icon: 'lightbulb', description: 'Legal advisory services' },
      { name: 'Notaries', icon: 'pen', description: 'Notary services' },
    ]
  },
  {
    name: 'Medical & Healthcare',
    icon: 'stethoscope',
    description: 'Cards for healthcare professionals',
    subcategories: [
      { name: 'Doctors', icon: 'stethoscope', description: 'General physicians and specialists' },
      { name: 'Dentists', icon: 'smile', description: 'Dental professionals' },
      { name: 'Surgeons', icon: 'activity', description: 'Surgical specialists' },
      { name: 'Physiotherapists', icon: 'bone', description: 'Physical therapy' },
      { name: 'Eye Specialists', icon: 'eye', description: 'Ophthalmologists and opticians' },
      { name: 'Cardiologists', icon: 'heartpulse', description: 'Heart specialists' },
      { name: 'Pharmacy', icon: 'pill', description: 'Pharmacists and drug stores' },
      { name: 'Veterinary', icon: 'dog', description: 'Animal healthcare' },
      { name: 'Hospitals & Clinics', icon: 'siren', description: 'Healthcare facilities' },
    ]
  },
  {
    name: 'Technology & IT',
    icon: 'code',
    description: 'Cards for tech professionals',
    subcategories: [
      { name: 'Software Engineers', icon: 'code', description: 'Software developers' },
      { name: 'IT Services', icon: 'monitor', description: 'IT support and services' },
      { name: 'Web Development', icon: 'laptop', description: 'Web developers and designers' },
      { name: 'Networking', icon: 'wifi', description: 'Network engineers' },
      { name: 'Electronics', icon: 'zap', description: 'Electronics and hardware' },
    ]
  },
  {
    name: 'Education',
    icon: 'graduationcap',
    description: 'Cards for educators and institutions',
    subcategories: [
      { name: 'Teachers', icon: 'bookopen', description: 'School teachers' },
      { name: 'Professors', icon: 'graduationcap', description: 'University professors' },
      { name: 'Tutors', icon: 'pen', description: 'Private tutors and coaches' },
      { name: 'Institutes', icon: 'building2', description: 'Training institutes and academies' },
    ]
  },
  {
    name: 'Real Estate',
    icon: 'home',
    description: 'Cards for real estate professionals',
    subcategories: [
      { name: 'Agents', icon: 'home', description: 'Real estate agents and brokers' },
      { name: 'Builders', icon: 'hammer', description: 'Construction and builders' },
      { name: 'Interior Designers', icon: 'palette', description: 'Interior design' },
      { name: 'Property Managers', icon: 'building2', description: 'Property management' },
      { name: 'Architects', icon: 'compass', description: 'Architecture firms' },
    ]
  },
  {
    name: 'Finance & Banking',
    icon: 'calculator',
    description: 'Cards for finance professionals',
    subcategories: [
      { name: 'Accountants', icon: 'calculator', description: 'CAs and accountants' },
      { name: 'Financial Advisors', icon: 'circledollarsign', description: 'Investment advisory' },
      { name: 'Insurance', icon: 'shield', description: 'Insurance agents' },
      { name: 'Banking', icon: 'landmark', description: 'Banking professionals' },
    ]
  },
  {
    name: 'Creative & Design',
    icon: 'palette',
    description: 'Cards for creative professionals',
    subcategories: [
      { name: 'Graphic Designers', icon: 'pentool', description: 'Graphic design' },
      { name: 'Photographers', icon: 'camera', description: 'Photography services' },
      { name: 'Videographers', icon: 'film', description: 'Video production' },
      { name: 'Artists', icon: 'brush', description: 'Fine arts and illustrations' },
      { name: 'Film & Cinema', icon: 'clapperboard', description: 'Film production' },
    ]
  },
  {
    name: 'Fitness & Sports',
    icon: 'dumbbell',
    description: 'Cards for fitness and sports professionals',
    subcategories: [
      { name: 'Gym Trainers', icon: 'dumbbell', description: 'Personal trainers' },
      { name: 'Yoga Instructors', icon: 'heart', description: 'Yoga and meditation' },
      { name: 'Sports Coaches', icon: 'award', description: 'Sports coaching' },
      { name: 'Nutritionists', icon: 'leaf', description: 'Diet and nutrition' },
    ]
  },
  {
    name: 'Beauty & Wellness',
    icon: 'scissors',
    description: 'Cards for beauty and wellness professionals',
    subcategories: [
      { name: 'Salons', icon: 'scissors', description: 'Hair and beauty salons' },
      { name: 'Makeup Artists', icon: 'sparkles', description: 'Makeup and cosmetics' },
      { name: 'Spa & Wellness', icon: 'flower2', description: 'Spa and relaxation' },
      { name: 'Skincare', icon: 'smile', description: 'Dermatology and skincare' },
    ]
  },
  {
    name: 'Food & Hospitality',
    icon: 'utensilscrossed',
    description: 'Cards for food and hospitality industry',
    subcategories: [
      { name: 'Restaurants', icon: 'utensilscrossed', description: 'Restaurant owners and staff' },
      { name: 'Chefs', icon: 'utensils', description: 'Professional chefs' },
      { name: 'Cafes', icon: 'coffee', description: 'Cafe owners' },
      { name: 'Bakeries', icon: 'cake', description: 'Bakery and confectionery' },
      { name: 'Hotels', icon: 'building2', description: 'Hotel and hospitality' },
      { name: 'Bars & Lounges', icon: 'wine', description: 'Bars and nightlife' },
    ]
  },
  {
    name: 'Travel & Transport',
    icon: 'plane',
    description: 'Cards for travel and transport industry',
    subcategories: [
      { name: 'Travel Agents', icon: 'plane', description: 'Travel agencies' },
      { name: 'Tour Guides', icon: 'mappin', description: 'Tourism and guides' },
      { name: 'Logistics', icon: 'truck', description: 'Transport and logistics' },
      { name: 'Automotive', icon: 'car', description: 'Auto dealers and services' },
    ]
  },
  {
    name: 'Media & Entertainment',
    icon: 'mic',
    description: 'Cards for media and entertainment professionals',
    subcategories: [
      { name: 'Musicians', icon: 'music', description: 'Musicians and bands' },
      { name: 'DJs', icon: 'headphones', description: 'DJs and events' },
      { name: 'Journalists', icon: 'newspaper', description: 'Media and journalism' },
      { name: 'Podcasters', icon: 'mic', description: 'Podcast hosts' },
      { name: 'Television', icon: 'tv', description: 'TV and broadcast' },
    ]
  },
  {
    name: 'Fashion & Jewelry',
    icon: 'shirt',
    description: 'Cards for fashion industry',
    subcategories: [
      { name: 'Fashion Designers', icon: 'shirt', description: 'Fashion design' },
      { name: 'Boutiques', icon: 'store', description: 'Boutiques and retail' },
      { name: 'Jewelry', icon: 'gem', description: 'Jewelry designers and stores' },
      { name: 'Luxury Brands', icon: 'crown', description: 'Premium and luxury' },
    ]
  },
  {
    name: 'Manufacturing & Industry',
    icon: 'factory',
    description: 'Cards for manufacturing and industry',
    subcategories: [
      { name: 'Factories', icon: 'factory', description: 'Factory owners' },
      { name: 'Exporters', icon: 'globe', description: 'Import and export' },
      { name: 'Warehousing', icon: 'warehouse', description: 'Warehouse and storage' },
      { name: 'E-commerce', icon: 'package', description: 'Online retail' },
    ]
  },
  {
    name: 'Government',
    icon: 'landmark',
    description: 'Cards for government officials',
    subcategories: [
      { name: 'Officials', icon: 'landmark', description: 'Government officers' },
      { name: 'Politicians', icon: 'users', description: 'Political leaders' },
    ]
  },
  {
    name: 'Agriculture',
    icon: 'leaf',
    description: 'Cards for agriculture professionals',
    subcategories: [
      { name: 'Farmers', icon: 'leaf', description: 'Farming and agribusiness' },
      { name: 'Horticulture', icon: 'flower2', description: 'Gardening and horticulture' },
      { name: 'Forestry', icon: 'treepine', description: 'Forestry and timber' },
    ]
  },
  {
    name: 'NGO & Social',
    icon: 'heart',
    description: 'Cards for non-profit and social organizations',
    subcategories: [
      { name: 'NGOs', icon: 'heart', description: 'Non-profit organizations' },
      { name: 'Social Workers', icon: 'users', description: 'Social service' },
      { name: 'Charities', icon: 'handmetal', description: 'Charitable organizations' },
    ]
  },
  {
    name: 'Freelancers',
    icon: 'laptop',
    description: 'Cards for freelance professionals',
    subcategories: [
      { name: 'Content Writers', icon: 'pen', description: 'Content creation and writing' },
      { name: 'Virtual Assistants', icon: 'monitor', description: 'Remote assistance' },
      { name: 'Consultants', icon: 'lightbulb', description: 'Independent consultants' },
    ]
  },
  {
    name: 'Religious & Spiritual',
    icon: 'church',
    description: 'Cards for religious and spiritual leaders',
    subcategories: [
      { name: 'Churches', icon: 'church', description: 'Churches and parishes' },
      { name: 'Spiritual Leaders', icon: 'star', description: 'Spiritual advisors' },
    ]
  },
];
